// extracted by css-extract-rspack-plugin
export default {"CopyButton":"U7zTz","CopyIcon":"vzcTu","InfoIcon":"dSpr8"};